export default __webpack_public_path__ + "static/1327-7886eb3d462b9e28e3efc04bf0e36eeb.gif";